export const EE_SHOW_MOBILE_NAV = 'EE_SHOW_MOBILE_NAV';

export const EE_HIDE_MOBILE_NAV = 'EE_HIDE_MOBILE_NAV';
